import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext'; // Assuming this exists

const FeatureFlagContext = createContext({});

export const FeatureFlagProvider = ({ children }) => {
  const { user, currentCompany } = useAuth();
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchFlags = async () => {
      // Only fetch flags if the user is authenticated and we have an API endpoint
      if (user) {
        try {
          // Assume API is configured with axios instance with auth headers
          const response = await api.get('/feature-flags');
          if (isMounted && response.data?.success) {
            setFlags(response.data.data || {});
          }
        } catch (error) {
          console.error('[FeatureFlagContext] Failed to fetch feature flags:', error);
          if (isMounted) {
            setFlags({}); // Fail open/default to empty
          }
        } finally {
          if (isMounted) {
            setLoading(false);
          }
        }
      } else {
        if (isMounted) {
          setFlags({});
          setLoading(false);
        }
      }
    };

    fetchFlags();

    return () => {
      isMounted = false;
    };
  }, [user, currentCompany]); // Refetch if user or company context changes

  return (
    <FeatureFlagContext.Provider value={{ flags, loading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlagContext = () => useContext(FeatureFlagContext);
